<div class="confirm-modal ig-modal info-modal">
    <div class="close-button">
        <mat-icon (click)="close()">clear</mat-icon>
    </div>
    <div class="title">{{title}}</div>

    <div #div class="info-body">
        <div *ngFor="let t of info;let i = index" class="flex">
            <mat-icon *ngIf="icons&&icons[i]" [ngStyle]="{'color':icons[i].color}">{{icons[i].icon}}</mat-icon>
            <span #text>{{t}}</span>
        </div>
        <div *ngIf="code" [innerHTML]="code"></div>
    </div>

    <div *ngIf="showCopy" class="flex" style="float:right">
        <div class="cancel-btn pointer" style="text-decoration: underline;" (click)="copy()">
            Copy to Clipboard
        </div>
        <div class="cancel-btn pointer" style="margin: 0 20px 0 51px" (click)="close()">
            Close
        </div>
    </div>

    <div *ngIf="!showCopy" class="cancel-btn pointer" (click)="close()">
        Close
    </div>

</div>


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/show.info.modal/show.info.modal.component.html